import {Injectable} from '@angular/core';
import {Router, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate} from '@angular/router';
import {navigation} from '../_nav';

@Injectable()
export class FeatureGuard implements CanActivate, CanActivateChild {

  static hasAccess(path) {
    path = path.replace(/^\/|\/$/g, '');
    const user = JSON.parse(localStorage.getItem('currentUser'));

    if (user) {
      return user.features === true || (typeof user.features[path] !== 'undefined' && user.features[path] !== 0);
    }
    return false;
  }

  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let path = state.url.length > 0 ? state.url : 'notFound';

    for ( const key in route.params) {
      path = path.replace( route.params[key], '');
    }
    const access = FeatureGuard.hasAccess( path );
    if ( ! access ) {
      if (path != '/') {
        this.router.navigate(['/']);
      } else {
       for (let i = 0; i < navigation.length; i++) {
         const url = navigation[i].url;
         if (url != path && FeatureGuard.hasAccess(url)) {
           this.router.navigate([url]);
         }
       }
      }
    }

    return access;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let path = state.url.length > 0 ? state.url : 'notFound';

    for ( const key in route.params) {
      path = path.replace( route.params[key], '');
    }
    const access = FeatureGuard.hasAccess( path );
    if ( ! access ) {
      if (path != '/') {
        this.router.navigate(['/']);
      } else {
        for (let i = 0; i < navigation.length; i++) {
          const url = navigation[i].url;
          if (url != path && FeatureGuard.hasAccess(url)) {
            this.router.navigate([url]);
          }
        }
      }
    }
    return access;
  }
}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/guards/feature.guard.ts